export default "__VITE_ASSET__CzWnQyMz__"